import React, { useEffect, useState } from 'react';
import { t } from '../../i18n';
import { useFormatCurrency } from '../../utils/currencyContext';
import { ensureServerClock, serverNow } from '../../utils/serverClock';
import {
  blindsGoUpMinutes,
  blindsUpEndsAt,
  formatCountdown,
  isBlindsUpExpired,
  nextBlindsLabel,
  nextLevelLabel,
  remainingMs,
} from '../../utils/blindsGoUp';

// Same type as the running mm:ss / NEXT line (mute #8a857d).
const CLOCK_TOP = 'text-[13px] text-mute font-semibold tnum whitespace-nowrap';
const CLOCK_SUB = 'text-[10px] text-mute uppercase tracking-[0.08em] whitespace-nowrap';

// Header clock, just left of HAND #N. Hidden when Off. All phones tick from
// the same settings.blindsUpStartedAt + .info/serverTimeOffset.
export default function BlindsUpClock({ settings }) {
  const formatCurrency = useFormatCurrency();
  const minutes = blindsGoUpMinutes(settings);
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!minutes) return undefined;
    ensureServerClock();
    const id = setInterval(() => setTick((n) => n + 1), 250);
    return () => clearInterval(id);
  }, [minutes]);

  if (!minutes) return null;

  const now = serverNow();
  const endsAt = blindsUpEndsAt(settings, minutes);
  if (endsAt == null) return null;

  const expired = isBlindsUpExpired(settings, now);
  const left = remainingMs(endsAt, now);
  const showExpired = expired || left == null || left <= 0;
  const next = showExpired
    ? nextLevelLabel(settings?.smallBlind, settings?.bigBlind, formatCurrency)
    : t('blinds.next', {
      label: nextBlindsLabel(settings?.smallBlind, settings?.bigBlind, formatCurrency).replace(/^NEXT\s+/, ''),
    });

  return (
    <div
      className="flex flex-col items-end justify-center leading-tight min-w-0"
      data-testid="blinds-up-clock"
      data-expired={showExpired ? 'true' : 'false'}
    >
      {showExpired ? (
        <>
          <span className={CLOCK_TOP} data-testid="blinds-up-flag">
            {t('blinds.nextHand')}
          </span>
          <span className={CLOCK_SUB} data-testid="blinds-up-next">
            {next}
          </span>
        </>
      ) : (
        <>
          <span className={CLOCK_TOP} data-testid="blinds-up-countdown">
            {formatCountdown(left)}
          </span>
          <span className={CLOCK_SUB} data-testid="blinds-up-next">
            {next}
          </span>
        </>
      )}
    </div>
  );
}
